import { create } from 'zustand';

type ToastSeverity = 'success' | 'error' | 'warning' | 'info';

interface ToastMessage {
  id: string;
  message: string;
  severity: ToastSeverity;
}

interface ToastState {
  toasts: ToastMessage[];
  showToast: (message: string, severity: ToastSeverity) => void;
  removeToast: (id: string) => void;
}

const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  // Dieselbe Meldung nur einmal zeigen: zentraler 422-Toast und Aufrufer, der den
  // Servertext selbst meldet, sagen sonst zweimal dasselbe.
  showToast: (message, severity) =>
    set((state) =>
      state.toasts.some((t) => t.message === message && t.severity === severity)
        ? state
        : { toasts: [...state.toasts, { id: Date.now().toString(), message, severity }] },
    ),
  removeToast: (id) =>
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    })),
}));

export default useToastStore;
